import { defineComponent as _defineComponent } from 'vue'
import { useAuth } from '@/store/auth';
import { useEntitlements } from '@/store/entitlements';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import GearIcon from '@/resources/icon-settings.svg';
import LogoType from '../LogoType.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'app-header',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();


const entitlements = useEntitlements();
const auth = useAuth();

const daysLeftOnTrial = computed(() => {
	if(entitlements?.userEntitlement?.trialEnds){
		return getDifferenceInDays(entitlements.userEntitlement.trialEnds);
	}
	return null;
});

function getDifferenceInDays(givenDate: string) {
	const now = new Date(); // Get the current date
	const date = new Date(givenDate); // Convert the given date to a Date object

	// Calculate the difference in milliseconds
	const differenceInTime = date.getTime() - now.getTime();

	// Convert the difference from milliseconds to days
	const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

	return differenceInDays;
}
const goToLocation = (location: string)=>{
    router.push(location);
};
//const goToLocation = (location: string) => {
//	//router.push(location);
//    router.push({name: `${location}`, params: {pageState: 'login'}});
//};

const routeToAuth = (pageState:string) => {
    router.push({ name: 'Auth', params: { pageState: `${pageState}` } });
};



const __returned__ = { router, entitlements, auth, daysLeftOnTrial, getDifferenceInDays, goToLocation, routeToAuth, get useAuth() { return useAuth }, get useEntitlements() { return useEntitlements }, computed, get useRouter() { return useRouter }, get GearIcon() { return GearIcon }, LogoType }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})